import React from "react";
import IncentivesDashboard from "../utilities/incentives_dashboard/IncentivesDashboard";
import { useComplaintIncentives } from "./store";

const ComplaintIncentives = () => {
  const {
    complaintIncentivesData,
    fetchComplaintIncentives,
    fetchComplaintIncentivesFilter,
    complaintIncentivesFilterData,
    complaintIncentivesFilterDataLoading,
  } = useComplaintIncentives();

  return (
    <IncentivesDashboard
      title="Complaints Incentives Dashboard"
      fetchIncentives={fetchComplaintIncentives}
      fetchIncentivesFilter={fetchComplaintIncentivesFilter}
      incentivesData={complaintIncentivesData}
      incentivesFilterData={complaintIncentivesFilterData}
      incentivesFilterDataLoading={complaintIncentivesFilterDataLoading}
    />
  );
};

export default ComplaintIncentives;
